/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function ChangesPolicyCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Changes to this Privacy Policy</Title>
      <Divider my="md" />
      <Text>
        We may update Our Privacy Policy from time to time. We will notify You
        of any changes by posting the new Privacy Policy on this page.
      </Text>

      <Text mt="sm">
        We will let You know via email and/or a prominent notice on Our Service,
        prior to the change becoming effective and update the "Last updated"
        date at the top of this Privacy Policy.
      </Text>

      <Text mt="sm">
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </Text>
    </Card>
  );
}
